import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FsProps } from 'motion-components';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getMaterialGroups(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: guid
        description: matGroupName
      }
      recordCount
    }
  }
`;

function useGetValues() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
}

type Props = {
  isMulti?: boolean;
} & FsProps;

export const FieldSelectMaterialGroup = ({
  label = 'Ομάδες Αποβλήτων',
  name = 'matGroupGuid',
  isMulti = false,
  defaultValues = {},
  ...rest
}: Props) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      // @ts-ignore
      sbLabel={defaultValues?.materialGroup?.name ?? undefined}
      isMulti={isMulti}
      hook={useGetValues}
    />
  );
};

